import * as React from "react";
import Typography from "@material-ui/core/Typography";
import { getValueFormatter, ISchemaKey, getAdditionalAttributes } from "helpers/product-collection";
import classNames from "classnames";
import get from "lodash/get";
import { DefaultRenderer } from "./product-collection-views/product-collection-grid-view/grid-renderers/default-renderer";
import { toDataTest } from "helpers/test";

interface IProductCollectionItemSizeField {
    label: string;
    value: string;
    fieldSchema?: ISchemaKey;
    styles?: any;
    className?: string;
}

export const ProductCollectionItemSizeField: React.FunctionComponent<IProductCollectionItemSizeField> = ({
    label,
    value,
    fieldSchema,
    styles,
    className,
}) => {
    const cellRendererParams = React.useMemo(() => {
        if (!fieldSchema) {
            return {};
        }

        const additionalAttributes = getAdditionalAttributes(fieldSchema, {});
        return get(additionalAttributes, "cellRendererParams", {});
    }, [fieldSchema]);

    const formatValue = React.useCallback(
        (arg) => (fieldSchema ? getValueFormatter(fieldSchema)({ value: arg }) : arg),
        [fieldSchema]
    );

    return (
        <div
            data-test={`${toDataTest(label)}-header`}
            {...(styles || {})}
            className={classNames("sizeInfo", className)}
        >
            <Typography>{label}</Typography>
            <div data-test={`${toDataTest(label)}-value`} className="field">
                <DefaultRenderer
                    {...{
                        column: undefined,
                        node: {},
                        rowIndex: undefined,
                        onSearchChange: undefined,
                    }}
                    colDef={{ cellRendererParams }}
                    formatValue={formatValue}
                    value={value}
                />
            </div>
        </div>
    );
};
